<template>
    <DashboardCard
            :width="width"
            :dataDisplay="dataDisplay"
            :color="color"
            :icons="icons"
            :title="title"
            :load_url="load_url">
    </DashboardCard>
</template>

<script>
    import DashboardCard from '../../widgets/DashboardCard';
    export default {
        name: 'CallsPerCampaign',
        components: {DashboardCard},
        props: {
            width: {type:Number, default: 25},
            dataDisplay: {type:String, default: null},
        },
        data() {
            var labels = [];
            for(var i = 8; i <= 17;i++){
                labels[i-8] = 'Hour '+i;
            }
            return {
                icons:labels,
                chart_type: 'bar',
                color: 'rgba(233, 196, 106, .6)',
                title: 'Calls per Campaign',
                load_url: '/dashboards/CallsPerCampaign',
                time_wait: 10000,
                chart_layout: [
                    {
                        'label': 'Calls per Campaign',
                        'backgroundColor': 'rgb(0,0,158)', //can be an array for other graph types
                        'borderColor': '#00b',
                        'pointBackgroundColor': 'rgba(220, 220, 220, 0)',
                        'pointBorderColor': '#fff',
                        'pointHighlightFill': 'rgba(220, 220, 220, 0)',
                        'pointHighlightStroke': 'rgba(220, 220, 220, 0)',
                    },
                ],
            };
        },
    };
</script>

<style scoped>

</style>